export default "__VITE_ASSET__CMD74ZRF__"